import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, cardItemMetaModel } from "common/models/utility-models/meta-model";

export class ReportsGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Reports',
            ROUTE_PATH.branchCategory,
            ROUTE_PATH.branchCategoryAdd,
            true,
            false,
            8,
            false,
            true,
            ['branchCatName']
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        return headers;
    }
}

export class ReportsCardMetaModel extends cardItemMetaModel {
}